/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallExecutionRecord } from './CallExecutionRecord';
import {
    CallExecutionRecordFromJSON,
    CallExecutionRecordFromJSONTyped,
    CallExecutionRecordToJSON,
} from './CallExecutionRecord';

/**
 * 
 * @export
 * @interface FindAllCallExecutions200Response
 */
export interface FindAllCallExecutions200Response {
    /**
     * 
     * @type {Array<CallExecutionRecord>}
     * @memberof FindAllCallExecutions200Response
     */
    data?: Array<CallExecutionRecord>;
}

/**
 * Check if a given object implements the FindAllCallExecutions200Response interface.
 */
export function instanceOfFindAllCallExecutions200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllCallExecutions200ResponseFromJSON(json: any): FindAllCallExecutions200Response {
    return FindAllCallExecutions200ResponseFromJSONTyped(json, false);
}

export function FindAllCallExecutions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCallExecutions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CallExecutionRecordFromJSON)),
    };
}

export function FindAllCallExecutions200ResponseToJSON(value?: FindAllCallExecutions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CallExecutionRecordToJSON)),
    };
}

